import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ClipLoader } from "react-spinners";
import PostCard from "../components/PostCard";
import PostInput from "../components/PostInput";
import PostInputMobile from "../components/PostInputMobile";
import { getTimeline } from "../api/timeline";
import { Post } from "../types/Post";
import { breakpoints } from "../styles/theme";

const Home: React.FC = () => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const timelinePosts = await getTimeline();
        setPosts(timelinePosts);
      } catch (err: unknown) {
        setError("Failed to load posts.");
        if (err instanceof Error) {
          console.error(err.message);
        } else {
          console.error(err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  return (
    <TimelineContainer>
      <PostInput />
      <PostInputMobile />
      {loading && <ClipLoader />}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {posts.map((post) => (
        <PostCard key={post.id} post={post} />
      ))}
    </TimelineContainer>
  );
};

const TimelineContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding-top: 0;

  @media (max-width: ${breakpoints.mobile}) {
    padding-top: 50px;
  }
`;

export default Home;
